export const DropPosition = {
  BEFORE: 'before',
  AFTER: 'after'
};